<template>
    <div>
        <div class="d-md-flex flex-row-reverse justify-content-between align-items-baseline">
            <div class="w-100">
                <button-dropdown-settings-nav :route-label="routeLabel" />

                <navs class="custom__nav">
                    <li class="nav-item" v-for="route in $router.options.routes" v-if="!route.redirect">
                        <router-link class="nav-link" :to="route.path">
                            <span v-if="route.icon" v-html="route.icon"></span>{{ route.label }}
                        </router-link>
                    </li>
                </navs>
            </div>

            <button-open-filter />
        </div>
        <transition name="fade-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    export default {
        computed: {
            routeLabel() {
                let route = this.$router.options.routes.find(route => route.path === this.$route.path);
                return route.label;
            },
        },
    }
</script>
